const ProfileTypes = {
  PROFILE: 'profile',
  CONTACT: 'contact',
};

module.exports = ProfileTypes;
